<template>
<!-- 联系我们 -->
  <div class="container contact">
    <el-row :gutter="100" class="contact-content">
      <el-col class="contact-box" :xs="24" :sm="24" :md="24" :lg="10" :xl="8">
        <div class="contact-desc">
          <p class="contact-sign mb10 flex-align-center">
            <i class="contact-dot mr5"></i>Contact us
          </p>
          <h1 class="contact-title">
            <span class="contact-c">联系</span>
            <span class="contact-u">我们</span>
          </h1>
          <p class="introduce">如果您有渲染需要，我们的团队将会为您提供强大的渲染服务以及优质的渲染质量，请联系我们</p>
          <div class="contact-btn">
            <ul class="contact-btn-list flex-align-center">
              <a href="tel:13581888127">
                <li class="mr20 ">
                  <div class="contact-icon-box">
                    <img src="../../assets/image/contact/phone.png" alt="">
                  </div>
                  <p class="contact-text">13581888127</p>
                </li>
              </a>
              <a class="" target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=11125120&site=qq&menu=yes">
                <li class="mr20 ">
                  <div class="contact-icon-box ">
                    <img src="../../assets/image/contact/qq.png" alt="">
                  </div>
                  <p class="contact-text">11125120</p>
                </li>
              </a>
              <li class="mr20 ">
                <div class="contact-icon-box ">
                  <img src="../../assets/image/contact/mail.png" alt="">
                </div>
                <p class="contact-text">zhang.tong@renderg.com</p>
              </li>
              <a target="_blank" href="https://map.baidu.com/search/%E5%8C%97%E4%BA%AC%E5%B8%82%E6%9C%9D%E9%98%B3%E5%8C%BA%E8%B4%A2%E6%BB%A1%E8%A1%97%E8%B4%A2%E7%BB%8F%E4%B8%AD%E5%BF%836%E5%8F%B7%E6%A5%BC16%E5%B1%82/@12973483.285,4827206.24,19z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%9C%9D%E9%98%B3%E5%8C%BA%E8%B4%A2%E6%BB%A1%E8%A1%97%E8%B4%A2%E7%BB%8F%E4%B8%AD%E5%BF%836%E5%8F%B7%E6%A5%BC16%E5%B1%82&c=131&src=0&pn=0&sug=0&l=19&b=(12970912.585,4831507.29;12971872.585,4831991.79)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1">
                <li class="mr20">
                  <div class="contact-icon-box">
                    <img src="../../assets/image/contact/address.png" alt="">
                  </div>
                  <p class="contact-text">北京市朝阳区财满街财经中心6号楼16层</p>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="16">
        <a target="_blank" href="https://map.baidu.com/search/%E5%8C%97%E4%BA%AC%E5%B8%82%E6%9C%9D%E9%98%B3%E5%8C%BA%E8%B4%A2%E6%BB%A1%E8%A1%97%E8%B4%A2%E7%BB%8F%E4%B8%AD%E5%BF%836%E5%8F%B7%E6%A5%BC16%E5%B1%82/@12973483.285,4827206.24,19z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%9C%9D%E9%98%B3%E5%8C%BA%E8%B4%A2%E6%BB%A1%E8%A1%97%E8%B4%A2%E7%BB%8F%E4%B8%AD%E5%BF%836%E5%8F%B7%E6%A5%BC16%E5%B1%82&c=131&src=0&pn=0&sug=0&l=19&b=(12970912.585,4831507.29;12971872.585,4831991.79)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1">
          <div class="contact-map">
            <el-image 
              class="hidden-lg-and-down"
              lazy
              src='https://cdn.renderg.com/download/www/renderg_dist/images/map.png'
              onerror="../../assets/image/loadimg/map.jpg"
              alt="">
              <div slot="placeholder" class="image-slot">
                <img src="../../assets/image/loadimg/map.jpg" alt="">
              </div>
            </el-image>
            <el-image 
              class="hidden-xl-only hidden-sm-only hidden-xs-only"
              lazy
              src='https://cdn.renderg.com/download/www/renderg_dist/images/map-md.png'
              onerror="../../assets/image/loadimg/map-md.jpg"
              alt="">
              <div slot="placeholder" class="image-slot">
                <img src="../../assets/image/loadimg/map-md.jpg" alt="">
              </div>
            </el-image>
            <el-image 
              class="hidden-xl-only hidden-lg-only hidden-md-only  hidden-xs-only"
              lazy
              src='https://cdn.renderg.com/download/www/renderg_dist/images/map-sm.png'
              onerror="../../assets/image/loadimg/map-sm.jpg"
              alt="">
              <div slot="placeholder" class="image-slot">
                <img src="../../assets/image/loadimg/map-sm.jpg" alt="">
              </div>
            </el-image>
            <el-image 
              class="hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only"
              lazy
              src='https://cdn.renderg.com/download/www/renderg_dist/images/map-xs.png'
              onerror="../../assets/image/loadimg/map-xs.jpg"
              alt="">
              <div slot="placeholder" class="image-slot">
                <img src="../../assets/image/loadimg/map-xs.jpg" alt="">
              </div>
            </el-image>
          </div>
        </a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: false,
    }
  },
}
</script>